import { ReactElement, useEffect } from 'react';
import { useUINav } from '@/ui';
import { useCompanyContext, useTeam } from '@/companies/providers';
import { DevicesList } from '@/devices/components';
import { usePagesTranslation } from '../../hooks';

export function TeamIdDevicesSettingsPage(): ReactElement {
    const { t } = usePagesTranslation();
    const { company } = useCompanyContext();
    const { team } = useTeam();

    const { setParts } = useUINav();
    useEffect(() => {
        setParts([
            {
                text: t('shared.labels.settings')
            },
            {
                text: t('shared.labels.teams'),
                link: `/company/${company.id}/settings/teams`
            },
            { text: team.name },
            { text: t('shared.labels.devices') }
        ]);
    }, [setParts, company.id, team.name, t]);

    return (
        <div
            style={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                gap: 24
            }}
        >
            <DevicesList companyId={company.id} teamId={team.id} />
        </div>
    );
}
